import { combineReducers } from 'redux';
import { IdentityReducer } from './IdentityReducer';
import { SearchReducer } from './SearchReducer';
import { VisitReducer } from './VisitReducer';
import { StatusReducer } from './StatusReducer';
import { RegisterReducer } from './RegisterReducer';


export const RootReducer = combineReducers({
    Profile: IdentityReducer,
    SearchData: SearchReducer,
    Visit: VisitReducer,
    Status: StatusReducer,
    Register: RegisterReducer
} as any); //bez any się nie skompiluje :(


// WEBPACK FOOTER //
// ./src/reducers/ReducersIndex.tsx